// libs
import { connect } from 'react-redux';

// components
import AboutDesigner from './AboutDesigner';

// selectors
import { getProductBrandUrl, getProductDesigner } from 'shared/store/details/selectors';

const mapStateToProps = (state: any) => ({
  designerData: getProductDesigner(state),
  actionURL: getProductBrandUrl(state),
});

export default connect(mapStateToProps)(AboutDesigner);
